import { route } from '@router/index.js';
import UniversalCookie from 'universal-cookie';

function getDomainConfigs(hostname) {
  // Handle localhost
  if (hostname === 'localhost') {
    return [undefined, 'localhost'];
  }

  // Split domain and get base domain (last two parts)
  const domainParts = hostname.split('.');
  const baseDomain = domainParts.slice(-2).join('.');

  // Build domain array, starting with common configs
  const domains = [undefined, `.${baseDomain}`, baseDomain];

  // Add full domain if it's a subdomain
  if (domainParts.length > 2) {
    domains.push(hostname);
  }

  return domains;
}

export async function logout() {
  // Set logout flag to prevent route loop
  window.isLogoutInProgress = true;

  try {
    {
      const [{ createOwnedChatClient }, push, user] = await Promise.all([
        import('@chat/runtime.js'),
        import('@utils/pushNotification/webPushNotification.js'),
        import('@states/User.js'),
      ]);
      const organizationId = Number(user.default.user?.selectedOrg || 0);
      if (Number.isSafeInteger(organizationId) && organizationId > 0) {
        const runtime = createOwnedChatClient({ organizationId });
        await push.revokeWebPushWithOwnedChat(runtime.client);
      }
    }
  } catch (error) {
    console.warn('Owned chat push revocation failed:', error);
  }

  // Clear current page storage
  localStorage.clear();
  sessionStorage.clear();

  const cookies = new UniversalCookie();
  const domains = getDomainConfigs(window.location.hostname);

  const paths = ['/'];

  const allCookies = cookies.getAll();

  // Remove each cookie for all domain/path combinations
  Object.keys(allCookies).forEach(cookieName => {
    domains.forEach(domain => {
      paths.forEach(path => {
        cookies.remove(cookieName, {
          path,
          domain,
          secure: window.location.protocol === 'https:',
          sameSite: 'strict',
        });
      });
    });
  });

  try {
    const states = await Promise.all([
      import('@states/ActiveResource.js'),
      import('@states/Organization.js'),
      import('@states/Preview.js'),
      import('@states/Projects.js'),
      import('@states/User.js'),
      // Add any other state files here
    ]);

    await Promise.all(
      states
        .map(module => module.default)
        .filter(state => state && typeof state.clear === 'function')
        .map(state => state.clear.bind(state)()),
    );

    route('/');
  } catch (e) {
    console.warn('State clear failed:', e);
  } finally {
    // Reset logout flag
    window.isLogoutInProgress = false;
  }
}
